import { ENDPOINTS } from 'api/endpoints';
import { useGetQuery } from 'api/useGetQuery';
import { useDataEnvironment } from 'contexts/DataEnvironmentContext';
import React, { Fragment } from 'react';

type Props = {
  // eslint-disable-next-line no-unused-vars
  onChange: (name: string) => void;
  initialName?: string;
  name?: string;
  available: boolean;
  // eslint-disable-next-line no-unused-vars
  setAvailability: (availability: boolean) => void;
};

type Availability = {
  available: boolean;
};

const Name: React.FC<Props> = ({
  onChange,
  initialName,
  name,
  available,
  setAvailability,
}: Props) => {
  const [dataEnvironment] = useDataEnvironment();
  const { isFetching, data } = useGetQuery<Availability>(
    ENDPOINTS.nameAvailability(dataEnvironment!.id, name),
  );

  if (data && !isFetching) {
    setAvailability(data.available);
  }

  const isAvailable = available;
  const hasInput = name && name.length && name !== initialName;

  return (
    <Fragment>
      <div className="form-row">
        <input
          className="form-control form-control-md"
          type="text"
          value={name}
          id="name"
          onChange={(event) => onChange(event.target.value)}
          style={{
            borderColor: !isAvailable && hasInput ? 'red' : undefined,
          }}
          autoComplete="off"
        />
      </div>
      {!isAvailable && hasInput ? (
        <small>
          <span style={{ color: 'red' }}>Name is not available</span>
        </small>
      ) : null}
    </Fragment>
  );
};

export default Name;
